import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const productsJswGuestAccessRoute: InvariantJiraRoute = {
	name: 'products-jsw-guest-access',
	path: '/jira/settings/products/jira-software-configuration/guest-access',
	exact: true,
};
